import { route, tag, type PageTour } from '../pageTour';

export const cameraGroupsTour: PageTour = {
  id: 'page-camera-groups',
  version: 1,
  title: 'Camera Groups',
  summary: 'Group cameras by area so walls and rules can use them together.',
  match: route('/camera-groups'),
  steps: [
    {
      target: tag('camera-groups-tree'),
      title: 'Pick a group',
      description: 'Select the group you want to work on. Groups can contain sub-groups.',
      side: 'right',
    },
    {
      target: tag('camera-groups-new'),
      title: 'New group',
      description: 'Create a group, such as a floor or building, to organise your cameras.',
      side: 'bottom',
      permission: 'groups.create',
    },
    {
      target: tag('camera-groups-filters'),
      title: 'Find cameras',
      description: 'Search by name, or filter by location, tag, or whether a camera is already in the group.',
      side: 'bottom',
    },
    {
      target: tag('camera-groups-grid'),
      title: 'Add or remove cameras',
      description: 'With a group selected, click a camera to add it to or remove it from the group. Cameras already in the group are listed first.',
      side: 'top',
    },
    {
      target: tag('camera-groups-save'),
      title: 'Save changes',
      description: 'Your changes are only kept once you save them.',
      side: 'bottom',
      permission: 'groups.assign',
    },
  ],
};
